export namespace IGetAchMessagingResponse {
  export type AchBannerSurfaceType =
    | 'ACH_BANNER_SURFACE_UNKNOWN'
    | 'ORDERS'
    | 'POST_ORDERS'
    | 'INVOICES'
    | 'ACCOUNT_SETTINGS';

  /**
   * The page where the banner should appear
   */
  export enum AchBannerSurface {
    ACH_BANNER_SURFACE_UNKNOWN = 'ACH_BANNER_SURFACE_UNKNOWN',
    ORDERS = 'ORDERS',
    POST_ORDERS = 'POST_ORDERS',
    INVOICES = 'INVOICES',
    ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS',
  }

  export type AchOfferTypeType =
    | 'ACH_OFFER_TYPE_UNKNOWN'
    | 'PROACTIVE_LIMIT_INCREASE'
    | 'TERMS_PRE_APPROVAL_ACH_LINK'
    | 'TERMS_PRE_APPROVAL';

  export enum AchOfferType {
    ACH_OFFER_TYPE_UNKNOWN = 'ACH_OFFER_TYPE_UNKNOWN',
    PROACTIVE_LIMIT_INCREASE = 'PROACTIVE_LIMIT_INCREASE',
    /**
     * Requires linking ACH to claim terms offer
     */
    TERMS_PRE_APPROVAL_ACH_LINK = 'TERMS_PRE_APPROVAL_ACH_LINK',
    TERMS_PRE_APPROVAL = 'TERMS_PRE_APPROVAL',
  }

  export namespace IBannerData {
    /**
     * Return an instance of IBannerData with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<IBannerData>): IBannerData =>
      ({
        ...(partial ?? {}),
      }) as IBannerData;
  }

  export interface IBannerData {
    title: string | undefined;
    message: string | undefined;
    foot_note: string | undefined;
    cta_text: string | undefined;
  }

  /**
   * Return an instance of IGetAchMessagingResponse with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IGetAchMessagingResponse>
  ): IGetAchMessagingResponse =>
    ({
      ...(partial ?? {}),
    }) as IGetAchMessagingResponse;
}

export interface IGetAchMessagingResponse {
  banner_data: IGetAchMessagingResponse.IBannerData | undefined;
  ach_offer_type:
    | keyof typeof IGetAchMessagingResponse.AchOfferType
    | undefined;
}
